import { createContext, useState } from 'react'

const FriendsContext = createContext()

export const FriendsProvider = ({ children }) => {
   const [friendsData, setFriendsData] = useState({ //items are just usernames
      blocked: [],
      current: [],
      pending: [],
   })

   return <FriendsContext.Provider value = {{
      friendsData,
      setFriendsData
   }}>
      {children}
   </FriendsContext.Provider>
}

export default FriendsContext